var _style, _g, _path, _rect, _path2, _defs, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLemonJuice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#315CA6;}\n\t.st1{fill:#FDCB50;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#77B154;}\n\t.st4{clip-path:url(#SVGID_2_);fill:#5C903A;}\n\t.st5{clip-path:url(#SVGID_2_);fill:#77B154;}\n\t.st6{clip-path:url(#SVGID_2_);fill:#FDCB50;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.5,182.8c42.7,0,77.3-34.3,77.3-76.6c0-42.3-34.6-76.6-77.3-76.6s-77.3,34.3-77.3,76.6 C29.2,148.5,63.8,182.8,106.5,182.8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.9,71.5c2.2,1,4,3.4,4,5.4v79.2c0,2-2.1,3.6-4.6,3.6H83.4c-2.5,0-4.6-1.6-4.6-3.6V76.9c0-2,1.8-4.4,4-5.4 l8.6-3.7c2.2-1,4-3.4,4-5.4v0.2c0-2-1.7-3.6-3.7-3.6c-2,0-3.7-1.6-3.7-3.6v-5.3c0-2,2.1-3.6,4.6-3.6H120c2.5,0,4.6,1.6,4.6,3.6v5.3 c0,2-1.7,3.6-3.7,3.6c-2,0-3.7,1.6-3.7,3.6v-0.2c0,2,1.8,4.4,4,5.4L129.9,71.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.3,
    y: 82.7,
    className: "st2",
    width: 46,
    height: 67.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.6,60.8H92.1c-3.6,0-6.5-2.9-6.5-6.5V52c0-3.6,2.9-6.5,6.5-6.5h28.5c3.6,0,6.5,2.9,6.5,6.5v2.3 C127.1,57.8,124.2,60.8,120.6,60.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 86.5,
    y: 94.2,
    width: 39.1,
    height: 39.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M98.9,97.9c7-1.4,9.2,1.4,12.7,0.1c3.5-1.3,0.1,3.1-0.8,3.8c-0.9,0.7-8.8,5.2-12.3,3.6 C95,103.7,95,98.6,98.9,97.9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.8,111.6c-0.3,0-0.7-0.2-0.9-0.4c-0.7-1-1.4-2.1-2.1-3.3c-2.5-4.1-5.3-8.8-12.4-10.4 c-0.6-0.1-1-0.7-0.8-1.3c0.1-0.6,0.7-1,1.3-0.8c0,0,0,0,0,0c8.1,1.8,11.3,7.1,13.8,11.4c0.7,1.1,1.3,2.2,2,3.1 c0.4,0.5,0.3,1.2-0.2,1.5C103.3,111.5,103,111.6,102.8,111.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M123.7,128.5C123.8,128.5,123.7,128.5,123.7,128.5c3-5.8,2.9-16.5-3.6-23c-6.3-6.3-14.9-6.3-20.4-4.4 c-1.7,0.7-3.2,0.1-4.1,1c-1,1-0.4,3-0.8,4.1c-3.4,5.6-3.7,14.1,2.9,20.8c5.4,5.4,11.3,7.4,21.7,5.3c0,0,0,0,0,0 c1.2-0.2,3.2,0.6,3.9-0.1C124.5,131.1,123.6,129.7,123.7,128.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.4,101.4c0,0-4.6-0.6-7.4,5c-2.8,5.6,0.6,9.9,0.3,13.7c-0.3,3.8,1.7,1.4,2.8-0.5c1.1-1.9,4.6-5.3,5.4-10.1 C97.3,104.8,96.4,102.6,95.4,101.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonJuice);
export default __webpack_public_path__ + "static/media/Lemon_juice.ade81bc1d9489293867eb4da7c6e5035.svg";
export { ForwardRef as ReactComponent };